import { render, staticRenderFns } from "./UsuariosFormPermisos.vue?vue&type=template&id=45885110&scoped=true&"
import script from "./UsuariosFormPermisos.vue?vue&type=script&lang=js&"
export * from "./UsuariosFormPermisos.vue?vue&type=script&lang=js&"
import style0 from "./UsuariosFormPermisos.vue?vue&type=style&index=0&id=45885110&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45885110",
  null
  
)

export default component.exports